var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 73,
    viewBox: "0 0 50 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2777_3298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2335 63.0106C7.85446 62.2283 5.47538 51.2764 4.68236 37.1953C3.88934 23.8965 9.44051 -1.91876 24.508 0.428082C36.4033 1.99265 43.5405 18.4206 45.1266 34.0662C46.7126 50.4941 45.1266 61.4461 41.1615 63.0106C37.9894 65.3575 14.9917 65.3575 10.2335 63.0106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2648 62.9156L10.2651 62.9147L10.2778 62.9209C10.8608 63.2085 11.7304 63.4632 12.8183 63.6827C13.9045 63.9018 15.2021 64.0848 16.6374 64.2312C19.508 64.5242 22.9245 64.6707 26.2923 64.6707C29.6602 64.6707 32.9772 64.5242 35.649 64.2313C36.985 64.0849 38.1578 63.9021 39.0942 63.6833C40.0346 63.4636 40.7232 63.2105 41.102 62.9302L41.1126 62.9224L41.1248 62.9176C42.0809 62.5403 42.9088 61.5903 43.5858 60.0969C44.2618 58.6055 44.7804 56.5869 45.1267 54.0984C45.8191 49.1221 45.8197 42.2858 45.0271 34.0761C44.235 26.2632 42.0572 18.2588 38.5958 12.0152C35.1333 5.76957 30.3973 1.30355 24.4949 0.527228L24.4949 0.527256L24.4926 0.526891C20.7587 -0.0546891 17.6156 1.10691 15.008 3.38801C12.3973 5.67177 10.3231 9.07851 8.74015 12.9822C5.57427 20.7896 4.38645 30.5531 4.78218 37.1894L4.7822 37.1897C5.17852 44.2267 5.97105 50.4795 6.96093 55.0689C7.45597 57.3641 7.99963 59.2397 8.56621 60.5884C8.84956 61.2628 9.13722 61.8021 9.42516 62.1952C9.7144 62.5902 9.99637 62.8274 10.2648 62.9156Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3298",
    x: 0.609375,
    y: 0.27832,
    width: 49.125,
    height: 72.4922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3298",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth24);
export default __webpack_public_path__ + "static/media/teeth24.9cf6b1a6e57c47f1aeef9ec0957d9288.svg";
export { ForwardRef as ReactComponent };